import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgLabelTwo extends LitElement {
    render() {
        return html `<p part="base"><slot></slot></p>`;
    }
}
AmityekoTgLabelTwo.styles = styles;
if (!customElements.get('amityeko-tg-label-two')) {
    customElements.define('amityeko-tg-label-two', AmityekoTgLabelTwo);
}
//# sourceMappingURL=index.js.map